var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'active': _vm.isActive },attrs:{"id":"menu-button"}},[_c('div',{staticClass:"menu-burger"})])}
var staticRenderFns = []

export { render, staticRenderFns }